import { format } from 'date-fns';
import { useCallback, useMemo, useState } from 'react';

const formatarData = (value) => (value ? format(value, 'yyyy-MM-dd') : null);

export default function useDashboardEvolucaoFiltro(aplicacoes = []) {
  const [dataInicio, setDataInicio] = useState(null);
  const [dataTermino, setDataTermino] = useState(null);
  const [idsSelecionados, setIdsSelecionados] = useState(null);
  const [idsResposta, setIdsResposta] = useState([]);

  const periodoInvalido =
    !!dataInicio &&
    !!dataTermino &&
    formatarData(dataInicio) > formatarData(dataTermino);
  const semAplicacoesSelecionadas =
    idsSelecionados !== null && idsSelecionados.length === 0;
  const parametros = useMemo(
    () => ({
      ...(dataInicio ? { dataInicio: formatarData(dataInicio) } : {}),
      ...(dataTermino ? { dataTermino: formatarData(dataTermino) } : {}),
      ...Object.fromEntries(
        (idsSelecionados || []).map((id, index) => [
          `formularioUsoIds[${index}]`,
          id,
        ])
      ),
    }),
    [dataInicio, dataTermino, idsSelecionados]
  );

  const registrarResposta = useCallback((dados) => {
    const payload = dados?.model || dados;
    const lista = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.aplicacoes)
      ? payload.aplicacoes
      : Array.isArray(payload?.usos)
      ? payload.usos
      : [];
    setIdsResposta(
      lista
        .filter((aplicacao) => aplicacao?.formularioUsoId != null)
        .map((aplicacao) => String(aplicacao.formularioUsoId))
    );
  }, []);

  const onAplicar = ({
    dataInicio: novoInicio,
    dataTermino: novoTermino,
    idsSelecionados: novosIds,
  }) => {
    const mesmoPeriodo =
      formatarData(novoInicio) === formatarData(dataInicio) &&
      formatarData(novoTermino) === formatarData(dataTermino);
    const mesmosIds =
      novosIds === idsSelecionados ||
      (novosIds?.length === idsSelecionados?.length &&
        novosIds?.every((id, index) => id === idsSelecionados[index]));
    if (mesmoPeriodo && mesmosIds) return;

    setDataInicio(novoInicio);
    setDataTermino(novoTermino);
    setIdsSelecionados(novosIds);
    setIdsResposta([]);
  };

  const onLimpar = () => {
    if (dataInicio || dataTermino || idsSelecionados !== null)
      setIdsResposta([]);
    setDataInicio(null);
    setDataTermino(null);
    setIdsSelecionados(null);
  };

  const onRemover = (campo) => {
    if (campo === 'dataInicio') setDataInicio(null);
    if (campo === 'dataTermino') setDataTermino(null);
    if (campo === 'idsSelecionados') setIdsSelecionados(null);
    setIdsResposta([]);
  };

  return {
    aplicacoes,
    dataInicio,
    dataTermino,
    idsSelecionados,
    idsResposta,
    parametros,
    periodoInvalido,
    semAplicacoesSelecionadas,
    temFiltros: !!dataInicio || !!dataTermino || idsSelecionados !== null,
    registrarResposta,
    onAplicar,
    onLimpar,
    onRemover,
  };
}
